import moment from 'moment'

export default function date (input) {
    if (!input) return ''
    const date = moment(input).format('DD-MM-YYYY')
    return date
}
